import React from 'react';

import { PrivacySettings } from 'src/components/account';
import { DetailPageLayout } from 'src/components/common';
import { useScreenInfo } from 'src/hooks/common';

export const PrivacySettingsPage: React.FC = () => {
  const { isMobile } = useScreenInfo();

  if (isMobile) {
    return <PrivacySettings />;
  }

  return (
    <DetailPageLayout titleContent="Privacy Settings">
      <PrivacySettings />
    </DetailPageLayout>
  );
};
